namespace GeniuzPOS.Common.Report {
    export interface ReportHeader extends Serenity.ListRequest {
        ShopName?: string;
        FillterString?: string;
        username?: string;
        Printdate?: string;
    }
}
